import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateMaintenanceServiceMetadata } from '../../api/maintenance-service.ts';
import { UpdateMaintenanceServiceMetadataRequest } from '../../api/requests/maintenance-service-request.ts';

export default function useUpdateMaintenanceServiceMetadata(): UseMutationResult<
  Awaited<ReturnType<typeof updateMaintenanceServiceMetadata>>,
  Error,
  UpdateMaintenanceServiceMetadataRequest
> {
  return useMutation({
    mutationFn: updateMaintenanceServiceMetadata,
  });
}
